// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","fullWidth":"ReportItem_fullWidth__RDIXw","halfWidth":"ReportItem_halfWidth__1BGMp","thirdWidth":"ReportItem_thirdWidth__1Iqe_"};